import { useQuery } from "react-query";
import { ReactQueryKeys } from "../../../../Constants/ClientRoutingConstants";
import { useAccountSettingsStore } from "../../../../Zustand/accountSettingsStore";
import LoadingSpinner from "../../../Shared/Components/LoadingSpinner";
import HealthTiles from "../Components/Account/HealthTiles";
import healthDashboardApiService from "../Utilities/HealthDashboardApiService";
import ErrorCard from "../../../Shared/Components/Cards/ErrorCard";
import { useLocation } from "react-router-dom";
import HealthMetricsReadDto from "../../../../Models/Dashboard/HealthMetricsReadDto";
import { enMessages } from "../../../../messages/en-US";
import { useLocalization } from "@progress/kendo-react-intl";

export default function HealthDashboardPage() {
  const softwareFeatures = useAccountSettingsStore((state) => state.softwareFeatures);
  const location = useLocation();
  const localizationService = useLocalization();
  // Get the selected tab from navigation state
  const initialSelectedTile = location.state?.selectedTile;

  const healthDashboardMetricsQuery = useQuery<HealthMetricsReadDto>(
    [ReactQueryKeys.AllHealthDashboardMetricsQuery], 
    async () => {
      return healthDashboardApiService.getHealthDashboardMetrics();
    }
  );

  // Show a loading spinner if softwareFeatures is not loaded yet
  if (!softwareFeatures || healthDashboardMetricsQuery.isLoading) {
    return <LoadingSpinner />;
  }

  if (healthDashboardMetricsQuery.isError) {
    return <ErrorCard />;
  }

  return (
    <div className='m-5'>
      <h2 className="pb-4 gb-h2 bg-white">
        {localizationService.toLanguageString('custom.healthDashboard', enMessages.custom.healthDashboard)}
      </h2>
      <HealthTiles 
        softwareFeatures={softwareFeatures} 
        healthData={healthDashboardMetricsQuery.data}
        initialSelectedTile={initialSelectedTile}
      />
    </div>
  );
}
